import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import {
  stateWithheld,
  w2Year,
} from "../../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import {
  addW4FormDocumentsStart,
  getAllTaxFormDocumentsStart,
} from "../../../../../../redux/slices/document/documentSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { v4 as uuidv4 } from "uuid";
const Tab1099Modal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { employeeProfileUiid } = useSelector((state) => state.employee);
  const [validationRules, setValidationRules] = useState({});
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      "1099Year": "",
      ein: "",
      "1099Amount": "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipCode: "",
      attachment: [],
    },
    {
      "1099Year": { type: "text", required: true },
      "1099Amount": { type: "text", number: true },
      zipCode: { type: "text", number: true },
      addressLine2: { type: "text", required: true },
      attachment: { type: "file", required: true },
    },
  );
  const handleSave = () => {
    const isValid = validateAllFields();

    if (!isValid) {
      console.log("Form errors:", errors);
      showToast("Please fill all the required fields before saving", "error");
      return;
    }

    const userFormData = {
      taxType: 3, // 3 indicates 1099
      addedBy: loginUserUiid,
      employeeId: employeeProfileUiid,
      year: formData?.["1099Year"] ?? "", // fallback if not filled
      ein: formData?.ein ?? "",
      amount: formData?.["1099Amount"] ?? "",
      address: {
        state: formData?.state ?? "",
        city: formData?.city ?? "",
        zipCode: formData?.zipCode ?? "",
        address1: formData?.addressLine1 ?? "",
        address2: formData?.addressLine2 ?? "",
      },
    };
    const submissionData = filterEmptyValues(userFormData);
    // Prepare attachments with UUID
    const cleanAttachments = Array.isArray(formData.attachment)
      ? formData.attachment.map((file) => {
          file.id = uuidv4();
          return file;
        })
      : [];
    if (cleanAttachments.length > 0) {
      dispatch(
        uploadStart({
          uploadType: "multiple",
          field: "doc",
          uiid: employeeProfileUiid,
          entity: "emptaxforms",
          category: "w4form",
          coll: "EmpTaxform",
          doc: cleanAttachments,
          onSuccess: async (fileData) => {
            dispatch(
              addW4FormDocumentsStart({
                coll: "EmpTaxform",
                payload: submissionData,
                onSuccess: async (response) => {
                  const taxFormId = response?.data?.data?.taxformId;
                  if (!taxFormId) return;
                  dispatch(
                    addDocumentStart({
                      coll: "Document",
                      refColl: "EmpTaxform",
                      refId: taxFormId,
                      refField: "documents",
                      payload: {
                        addedBy: loginUserUiid,
                        attachments: [
                          {
                            parent: { employee: employeeProfileUiid },
                            addedBy: loginUserUiid,
                            docType: "W4Form",
                            ref: {
                              id: taxFormId,
                              entity: "documents",
                              path: `documents`,
                            },
                            file: cleanAttachments.map((obj) => ({
                              name: obj.attachmentName,
                              comments: obj.attachmentComments,
                              keys: fileData
                                .filter(
                                  (file) =>
                                    file?.fileRefId === obj.id && file.key,
                                )
                                .map((file) => file.key),
                            })),
                          },
                        ],
                      },
                      onSuccess: async () => {
                        onClose();
                        dispatch(
                          getAllTaxFormDocumentsStart({
                            tab: "w4FormTab",
                            ret: "Form1099",
                            coll: "EmpTaxform",
                            fil: {
                              employeeId: {
                                type: "NONE",
                                value: employeeProfileUiid,
                              },
                              taxType: {
                                type: "NONE",
                                value: 3,
                              },
                            },
                            ref: "Document",
                          }),
                        );
                      },
                    }),
                  );
                },
              }),
            );
          },
        }),
      );
    }
    console.log("📝 Prepared Form Data:", userFormData);
  };

  console.log(formData["1099Year"], "checking the print are not");
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ADD 1099 FORM"
      width="max-w-7xl"
    >
      {/* <div className="grid grid-cols-3 gap-x-6 gap-y-6 "> */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
        <FormFieldSet
          type="select"
          title="1099 Year"
          placeholder="Select 1099 Year"
          value={formData["1099Year"]}
          onChange={(value) => handleChange("1099Year", value)}
          error={errors["1099Year"]}
          options={w2Year}
        />
        <FormFieldSet
          type="text"
          title="EIN"
          placeholder="Enter EIN"
          value={formData.ein}
          onChange={(value) => handleChange("ein", value)}
          error={errors.ein}
        />
        <FormFieldSet
          type="text"
          title="1099 Amount"
          placeholder="Enter 1099 Amount"
          value={formData["1099Amount"]}
          onChange={(value) => handleChange("1099Amount", value)}
          error={errors["1099Amount"]}
        />
        <FormFieldSet
          type="text"
          title="Address Line 1"
          placeholder="Enter Address Line 1"
          value={formData.addressLine1}
          onChange={(value) => handleChange("addressLine1", value)}
          error={errors.addressLine1}
        />
        <FormFieldSet
          type="text"
          title="Address Line 2"
          placeholder="Enter Address Line 2"
          value={formData.addressLine2}
          onChange={(value) => handleChange("addressLine2", value)}
          error={errors.addressLine2}
        />
        <FormFieldSet
          type="text"
          title="City"
          placeholder="Enter City"
          value={formData.city}
          onChange={(value) => handleChange("city", value)}
          error={errors.city}
        />
        <FormFieldSet
          type="select"
          title="State"
          placeholder="Select State"
          value={formData.state}
          onChange={(value) => handleChange("state", value)}
          error={errors.state}
          options={stateWithheld}
        />
        <FormFieldSet
          type="text"
          title="Zipcode"
          placeholder="Enter Zipcode"
          value={formData.zipCode}
          onChange={(value) => handleChange("zipCode", value)}
          error={errors.zipCode}
        />
        <FormFieldSet
          type="file"
          title="Attachment"
          placeholder="Choose Files"
          value={formData.attachment}
          multiple
          onChange={(value) => handleChange("attachment", value)}
          error={errors.attachment}
        />
      </div>
      <div className="flex gap-3 justify-end mt-10 my-10">
        <Button title="Cancel" variant="outlined" onClick={onClose} />
        <Button title="Save" onClick={() => handleSave()} />
      </div>
    </Modal>
  );
};

export default Tab1099Modal;
